
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.5 27.5c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13zm0-3c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zM1.44 41.245c5.011-7.038 12.41-11.26 20.47-11.4 8.702-.153 16.78 4.48 22.02 12.304a1.5 1.5 0 01-2.493 1.67c-4.695-7.011-11.84-11.108-19.475-10.975-7.068.123-13.599 3.85-18.078 10.14a1.5 1.5 0 11-2.444-1.74z"}})])
          )
        }
      }
    